import type { FC } from "react";
import "flagpack/dist/flagpack.css";

export interface CountryFlagDataDisplayProps {
  isoCode: string;
  size?: "small" | "medium" | "large";
  rounded?: boolean;
}

export const CountryFlagDataDisplay: FC<CountryFlagDataDisplayProps> = ({
  isoCode,
  rounded = false,
  size = "small",
}) => {
  const sizeClass = {
    small: "fp ",
    medium: "fp fp-md ",
    large: "fp fp-lg ",
  }[size];
  const roundedClass = rounded ? "fp-rounded " : "";
  return <span className={sizeClass + roundedClass + isoCode.toLowerCase()} />;
};
